import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Draggable from 'react-draggable';
import ResizeObserver from 'react-resize-observer';
import { PortWrapper, } from '../../';
import { noop } from '../../utils';
import { NodeDefault } from './Node.default';
export const NodeWrapper = ({ config, node, onDragNode, onNodeClick, isSelected, Component = NodeDefault, onNodeSizeChange, NodeInner, Ports, Port, offset, selected, selectedLink, hovered, hoveredLink, onPortPositionChange, onLinkStart, onLinkMove, onLinkComplete, onLinkCancel, }) => {
    const [size, setSize] = React.useState({ width: 0, height: 0 });
    const isDragging = React.useRef(false);
    const onStart = React.useCallback((e) => {
        // Stop propagation so the canvas does not move
        e.stopPropagation();
        isDragging.current = false;
    }, []);
    const onDrag = React.useCallback((event, data) => {
        isDragging.current = true;
        onDragNode({ config, event, data, id: node.id });
    }, [onDragNode, config, node.id]);
    const onClick = React.useCallback((e) => {
        if (!config.readonly) {
            e.stopPropagation();
            if (!isDragging.current) {
                onNodeClick({ config, nodeId: node.id });
            }
        }
    }, [config, node.id]);
    const compRef = React.useRef(null);
    // TODO: probably should add an observer to track node component size changes
    React.useLayoutEffect(() => {
        const el = ReactDOM.findDOMNode(compRef.current);
        if (el) {
            if ((node.size && node.size.width) !== el.offsetWidth ||
                (node.size && node.size.height) !== el.offsetHeight) {
                const newSize = { width: el.offsetWidth, height: el.offsetHeight };
                setSize(newSize);
                onNodeSizeChange({ config, nodeId: node.id, size: newSize });
            }
        }
    }, [node, compRef.current, size.width, size.height]);
    const children = (React.createElement(React.Fragment, null,
        React.createElement(ResizeObserver, { onResize: (rect) => {
                const newSize = { width: rect.width, height: rect.height };
                setSize(newSize);
            } }),
        React.createElement(NodeInner, { node: node, config: config }),
        React.createElement(Ports, { config: config }, Object.keys(node.ports).map((portId) => (React.createElement(PortWrapper, { config: config, key: portId, offset: offset, selected: selected, selectedLink: selectedLink, hoveredLink: hoveredLink, hovered: hovered, node: node, port: node.ports[portId], Component: Port, onPortPositionChange: onPortPositionChange, onLinkStart: config.readonly ? noop : onLinkStart, onLinkMove: config.readonly ? noop : onLinkMove, onLinkComplete: onLinkComplete, onLinkCancel: onLinkCancel }))))));
    return (React.createElement(Draggable, { bounds: "parent", axis: "both", position: node.position, grid: [1, 1], onStart: onStart, onDrag: onDrag, disabled: config.readonly },
        React.createElement(Component, { config: config, ref: compRef, children: children, onClick: onClick, isSelected: isSelected, node: node })));
};
